/*
Mixin for clearing select input and turbo frame with payment accounts.
Optional method clear_payment_accounts_callback can be defined in controller
to perform additional actions.
*/

export const ClearPaymentAccountsMixin = (controller) => {
  Object.assign(controller, {
    clear_payment_accounts(select_selector, turbo_frame_name) {
      $(document.querySelector(select_selector)).empty();

      const frame = document.querySelector(`turbo-frame#${turbo_frame_name}`);

      if (frame) {
        frame.innerHTML = '';
      }

      this.clear_payment_accounts_callback?.();
    },
  });
};
